import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import type { GameSummary } from '@/lib/types';
import { etb, etbInt } from '@/lib/money';
import { countdownSeconds } from '@/lib/bingo';
import { serverNow } from '@/lib/serverClock';

export function GameList({ games }: { games: GameSummary[] }) {
    const [now, setNow] = useState(() => serverNow());

    useEffect(() => {
        const id = window.setInterval(() => setNow(serverNow()), 250);
        return () => window.clearInterval(id);
    }, []);

    if (games.length === 0) {
        return <div className="lobby-empty">No open tables yet. Deposit in the bot, then come back.</div>;
    }

    return (
        <>
            <div className="lobby-head">
                <span>BET</span>
                <span>POSSIBLE WIN</span>
                <span>STATUS & JOIN</span>
            </div>
            {games.map((game) => {
                const cap =
                    game.jackpot_target ??
                    (game.max_tickets
                        ? game.max_tickets * game.stake_amount
                        : Math.max(game.prize_pool, game.stake_amount * 10));
                const pct = cap > 0 ? Math.min(100, (game.prize_pool / cap) * 100) : 0;
                const secs = countdownSeconds(game.countdown_ends_at, now);
                const counting = game.status === 'open' && secs !== null && secs > 0;
                const running = game.status === 'active' || (game.status === 'open' && secs === 0);
                const href = `/games/${game.id}/purchase`;
                const label = counting ? `${secs}s` : running ? 'running' : 'waiting';
                const pill = counting ? 'pill-count' : running ? 'pill-live' : 'pill-wait';

                return (
                    <Link key={game.id} to={href} className="game-card w-game-card">
                        <div className="game-card-row">
                            <div className="game-bet">{etb(game.stake_amount)} ETB</div>
                            <div>
                                <div className="game-win">{etb(game.possible_win ?? game.prize_pool)} ETB</div>
                                <span className={`pill ${pill}`}>{label}</span>
                            </div>
                            <div className="game-join-col">
                                <span className="game-join">Join</span>
                            </div>
                        </div>
                        <div className="game-bar-wrap">
                            <div className="game-bar" style={{ width: `${pct}%` }} />
                            <div className="game-bar-label">
                                JACKPOT {etbInt(game.prize_pool)} / {etbInt(cap)} ETB
                            </div>
                        </div>
                    </Link>
                );
            })}
        </>
    );
}
